// const globalMoonshineBaseUrl = 'https://toxicfox-test-2.s3.eu-west-1.amazonaws.com'
const globalMoonshineBaseUrl = 'https://moonshine-cd.vercel.app'

if (!Object.keys) {
  Object.keys = (function () {
    'use strict'
    var hasOwnProperty = Object.prototype.hasOwnProperty,
      hasDontEnumBug = !{ toString: null }.propertyIsEnumerable('toString'),
      dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor',
      ],
      dontEnumsLength = dontEnums.length

    return function (obj) {
      if (
        typeof obj !== 'function' &&
        (typeof obj !== 'object' || obj === null)
      ) {
        throw new TypeError('Object.keys called on non-object')
      }

      var result = [],
        prop,
        i

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop)
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i])
          }
        }
      }
      return result
    }
  })()
}

const toxicFoxBuilder = (function () {
  function init() {
    store.init()

    let productConfig = document.getElementById('moonshine_config_json')
      ? JSON.parse(document.getElementById('moonshine_config_json').innerHTML)
      : null

    let contentWindow = document.getElementById('builder').contentWindow
    characterBuilderUrl = "https://moonshine-cd.vercel.app?key=character1&tag=simple_couple"
    contentWindow.location.replace(characterBuilderUrl)

    /* // Old Style Config (single character)
    let brand = productConfig ? productConfig.brand : undefined

    let characterBuilderUrl = brand
      ? globalMoonshineBaseUrl + '/' + brand + '?key=character1'
      : globalMoonshineBaseUrl + '?key=character1'
    */

    // contentWindow.postMessage(
    //   {
    //     event: 'config',
    //     value: productConfig,
    //   },
    //   '*'
    // )

    if (productConfig) {
      Object.keys(productConfig).forEach(function (key) {
        store.set(key, productConfig[key])
      })
    }

    // caused jquery defer bug ?
    // window.save ? window.save() : null
  }

  function initStore() {
    let productConfig = JSON.parse(
      document.getElementById('moonshine_config_json').innerHTML
    )
    Object.keys(productConfig).forEach(function (key) {
      store.set(key, productConfig[key])
    })
  }

  function restart() {
    store.init()
    let productConfig = JSON.parse(
      document.getElementById('moonshine_config_json').value
    )

    let brand = productConfig ? productConfig.brand : undefined

    let characterBuilderUrl = brand
      ? globalMoonshineBaseUrl + '/' + brand + '?key=character1'
      : globalMoonshineBaseUrl + '?key=character1'

    document
      .getElementById('builder')
      .contentWindow.location.replace(characterBuilderUrl)

    Object.keys(productConfig).forEach(function (key) {
      store.set(key, productConfig[key])
    })
  }

  return {
    init: init,
    initStore: initStore,
    restart: restart,
  }
})()
